<template>
  <v-chart :style="styleChart" ref="chartRef" autoresize :option="option" />
</template>
<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart, LineChart } from "echarts/charts";
import {
  DataZoomComponent,
  TooltipComponent,
  GridComponent,
} from "echarts/components";
import VChart from "vue-echarts";
use([
  CanvasRenderer,
  BarChart,
  TooltipComponent,
  GridComponent,
  DataZoomComponent,
  LineChart,
]);
export default {
  props: {
    direction: {
      type: String,
      default: "X",
    },
    chartData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    VChart,
  },
  data() {
    return {
      styleChart: {width: '100%', height: '100%'}
      // option: {}
    };
  },
  watch: {
    chartData: {
      handler() {
        this.$nextTick(() => {
          const domRect = this.$parent.$el.getBoundingClientRect()
          let width = '100%'
          let height = '100%'
          const { columns } = this.chartData;
          if (this.direction === 'X') {
            if (columns && columns.length >= 9) {
              const sWidth = columns.length * 50
              if (domRect.width < sWidth) {
                width = `${sWidth}px`
              }
            }
          } else if (this.direction === 'Y') {
            if (columns && columns.length >= 9) {
              const sHeight = columns.length * 40
              if (domRect.height < sHeight) {
                height = `${sHeight}px`
              }
            }
          }
          this.styleChart = {width, height}
        })
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    option() {
      const _this = this
      const { columns, columnValues, dataMap } = this.chartData;
      const yAxis = {
        show: false,
        type: "value",
        min: 0,
        max: 100,
      };
      const xAxis = {
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false,
        },
        type: "category",
        data: columns,
        axisLabel: {
          show: true,
          formatter: function (params) {
            let newParamsName = "";
            const paramsNameNumber = params.length;
            const provideNumber = _this.direction === "Y" ? 4 : 3;
            var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
            if (paramsNameNumber > provideNumber) {
              for (var p = 0; p < rowNumber; p++) {
                var tempStr = "";
                var start = p * provideNumber;
                var end = start + provideNumber;
                if (p == rowNumber - 1) {
                  tempStr = params.substring(start, paramsNameNumber);
                } else {
                  tempStr = params.substring(start, end) + "\n";
                }
                newParamsName += tempStr;
              }
            } else {
              newParamsName = params;
            }
            return newParamsName;
          },
        },
      };
      const option = {
        grid: {
          left: this.direction === "Y" ? 70 : 20,
          top: this.direction === "Y" ? 20 : 40,
          right: this.direction === "Y" ? 70 : 20,
          bottom: this.direction === "Y" ? 20 : 60,
        },
        textStyle: {
          color: "#fff",
        },
        color: ["#06fcffdf"],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function (value) {
            let str0 = "";
            const dataIndex = value[0].dataIndex;
            const axisValueLabel = value[0].axisValueLabel;
            value.forEach((item, index) => {
              str0 = `${str0}${item.marker}${item.data}% ${dataMap[dataIndex].title}`;
              str0 = `${str0}${index === value.length - 1 ? "" : "<br/>"}`;
            });
            return `${axisValueLabel}<br/>${str0}`;
          },
        },
        xAxis: this.direction === "Y" ? yAxis : xAxis,
        yAxis: this.direction === "Y" ? xAxis : yAxis,
        series: [
          {
            data: columnValues,
            type: "bar",
            label: {
              show: true,
              color: "#fff",
              position: this.direction === "Y" ? "outside" : "top",
              formatter: function (value) {
                const dataIndex = value.dataIndex;
                return `${value.data}%\n${dataMap[dataIndex].title}`;
              },
            },
            showBackground: true,
            backgroundStyle: {
              color: "rgba(107, 103, 210, 1)",
              borderRadius: 12,
              borderType: "dashed",
            },
            itemStyle: {
              normal: {
                barBorderRadius: 12,
              },
            }
          },
        ],
      };
      return option;
    },
  },
  methods: {
    drawView() {
      const { columns: xData, columnValues } = this.chartData;
      const yData = columnValues.map((v) => v[0]);
      const option = {
        toolbox: {
          show: true,
          orient: "vertical",
          left: "right",
          top: "center",
          feature: {
            mark: { show: true },
            dataView: { show: false, readOnly: false },
            magicType: { show: false, type: ["bar"] },
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        xAxis: {
          type: "category",
          data: xData,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: yData,
            type: "bar",
            label: {
              show: true,
              position: "top",
            },
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
          },
        ],
      };
      this.option = option;
      if (this.$refs.chartRef) {
        this.$refs.chartRef.chart.setOption(this.option, true);
      }
    },
  },
};
</script>
